import {IFacilityType, IReportsTableHeaders} from '../../types';

const getStandardsTableHeaders = (providerType: IFacilityType = 'Provider') => [
    {
        className: 'county-type',
        items: [
            {},
            {label: 'LARGE METRO', colSpan: 2},
            {label: 'METRO', colSpan: 2},
            {label: 'MICRO', colSpan: 2},
            {label: 'RURAL', colSpan: 2},
            {label: 'CEAC', colSpan: 2}
        ]
    },
    {
        className: 'time-dist',
        items: [
            {label: `${providerType} Specialty Types`},
            {label: 'Time'},
            {label: 'Distance'},
            {label: 'Time'},
            {label: 'Distance'},
            {label: 'Time'},
            {label: 'Distance'},
            {label: 'Time'},
            {label: 'Distance'},
            {label: 'Time'},
            {label: 'Distance'}
        ]
    }
] as IReportsTableHeaders;

const getSummaryTableHeaders = (providerType: IFacilityType = 'Provider') => [
    {
        className: 'county-type',
        items: [
            {},
            {label: 'LARGE METRO', colSpan: 2},
            {label: 'METRO', colSpan: 2},
            {label: 'MICRO', colSpan: 2}
        ]
    },
    {
        className: 'time-dist',
        items: [
            {label: `${providerType} Specialty Types`},
            {label: 'Average Time'},
            {label: 'Average Distance'},
            {label: 'Average Time'},
            {label: 'Average Distance'},
            {label: 'Average Time'},
            {label: 'Average Distance'}
        ]
    }
] as IReportsTableHeaders;

const getAdequacyByCountyTableHeaders = (providerType: IFacilityType = 'Provider'): IReportsTableHeaders => [
    {
        className: 'adequacy-by-county-header',
        items: [
            {label: 'County'},
            {label: 'County Designation'},
            {label: '# of Providers within T/D'},
            ...(providerType === 'Facility' ? [{label: '# of Beds Available'}] : []),
            {label: 'County Members'},
            {label: 'Target (%)'},
            {label: 'Distance (%)'},
            {label: 'Time (%)'},
            {label: 'Status'},
            {label: 'Additional Providers within T/D'}
        ]
    }
];

export default {
    providerStandardsTableHeaders: getStandardsTableHeaders(),
    facilityStandardsTableHeaders: getStandardsTableHeaders('Facility'),
    providerSummaryTableHeaders: getSummaryTableHeaders(),
    facilitySummaryTableHeaders: getSummaryTableHeaders('Facility'),
    getAdequacyByCountyTableHeaders
};